import type { MessageKey } from 'types/LocaleMessageKey';

interface StatLine {
  id: number;
  figure: MessageKey;
  caption: MessageKey;
}

export const STAT_LINES: StatLine[] = [
  {
    id: 0,
    figure: 'about_us_stat_figure_1',
    caption: 'about_us_stat_caption_1',
  },
  {
    id: 1,
    figure: 'about_us_stat_figure_2',
    caption: 'about_us_stat_caption_2',
  },
  {
    id: 2,
    figure: 'about_us_stat_figure_3',
    caption: 'about_us_stat_caption_3',
  },
  {
    id: 3,
    figure: 'about_us_stat_figure_4',
    caption: 'about_us_stat_caption_4',
  },
];

//TODO: GROW-2475 Clean up after June 24th roll out
export const STAT_LINES_UPDATED: StatLine[] = [
  {
    id: 0,
    figure: 'about_us_stat_figure_1_updated',
    caption: 'about_us_stat_caption_1',
  },
  {
    id: 1,
    figure: 'about_us_stat_figure_2_updated',
    caption: 'about_us_stat_caption_2',
  },
  {
    id: 2,
    figure: 'about_us_stat_figure_3_updated',
    caption: 'about_us_stat_caption_3',
  },
  {
    id: 3,
    figure: 'about_us_stat_figure_4_updated',
    caption: 'about_us_stat_caption_4',
  },
];
